import React        from 'react';
import classNames        from 'classnames';
import { Observe }       from 'rewire-core';
import Button            from '@material-ui/core/Button';
import { Theme }         from '@material-ui/core/styles';
import CheckIcon         from '@material-ui/icons/CheckCircle';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import AutorenewIcon     from '@material-ui/icons/Autorenew';
import { makeStyles }    from '../utility/styles';
import batchSummaryModel from './BatchSummaryModel';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  button: {
    flex: '0 0 auto',
    alignSelf: 'center',
    margin: '0px 0px 7px 10px',
    '&:first-child': {
      marginLeft: '0px',
    }
  },
  acceptButton: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.light,
    },
  },
  deleteButton: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.light,
    },
  },
  downloadButton: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.light,
    },
  }
});

const useStyles = makeStyles(styles);

export default () => {
  const classes = useStyles();
  React.useEffect(() => {
    // const handle = setInterval(() => createBatchModel.loadData(), 3000);
    return () => {
      // clearInterval(handle);
    };
  }, []);

  return (
    <div className={classes.root}>
      <Observe>{() => (
        <>
          <Button className={classNames(classes.button, classes.downloadButton)} disabled={!batchSummaryModel.canDownload}   variant='contained' size='small' startIcon={<CloudDownloadIcon />} onClick={batchSummaryModel.downloadBatch}>Download</Button>
          <Button className={classNames(classes.button, classes.acceptButton)}   disabled={!batchSummaryModel.canAccept}     variant='contained' size='small' startIcon={<CheckIcon />}         onClick={batchSummaryModel.acceptBatch}>Accept</Button>
          <Button className={classNames(classes.button, classes.downloadButton)} disabled={!batchSummaryModel.canRegenerate} variant='contained' size='small' startIcon={<AutorenewIcon />}     onClick={batchSummaryModel.regenerateBatch}>Regenerate</Button>
        </>
      )}</Observe>
    </div>
  );
};